module.exports = __webpack_public_path__ + "static/media/add syllabus.6296bb8d.svg";